import { api } from './api'

export default {
  appName: 'نام اپ',
  pageTitle: {
    min: '',
    full: ''
  },
  noneToken: ['home'],
  api,

}
